import React from "react";
import { getIsPinned, updateIsPinned } from "@/containers/Sense/reducer";
import { useDispatch, useSelector } from "@/types/store";
import { Button } from "@/aible";
import PinnedIcon from "images/Sense-Icons/pinned-black.svg";
import UnpinnedIcon from "images/Sense-Icons/unpinned-black.svg";
const PinCell = ({ id, updatePin, type }) => {
    const dispatch = useDispatch();
    const isPinned = useSelector((state) => getIsPinned(state, id, type));
    const handleUpdateIsPinned = (isPinned, id) => {
        dispatch(updateIsPinned(id, isPinned, type));
        updatePin("top");
    };
    return (React.createElement("div", { className: "w-full flex justify-center items-center" },
        React.createElement(Button, { type: "transparent", style: { padding: "10px 5px", border: "none" }, onClick: (e) => {
                e.stopPropagation();
                handleUpdateIsPinned(!isPinned, id);
            }, className: "group [&>img]:w-3" },
            React.createElement("img", { src: isPinned ? PinnedIcon : UnpinnedIcon }))));
};
export default PinCell;
